import { faAngleRight, faCheck, faClose, faPlus, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Grid, Group, Input, Modal, MultiSelect, NumberInput, Text } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { Dropzone } from '@mantine/dropzone';
import { IconPercentage, IconUpload, IconEye, IconBell } from '@tabler/icons-react';
import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { BASE_URL } from '../../api/EndPoints';
import { createB2BAPI } from '../../api/Interceptor';
import B2BInput from '../../components/common/B2BInput';
import B2BPillsInput from '../../components/common/B2BPillsInput';
import B2BSelect from '../../components/common/B2BSelect';
import { ProductContext } from '../../Context/ProductContext';
import './ProductManagement.css'
import { useNavigate } from 'react-router-dom';
import notify from '../../utils/Notification';

const ProductManagement = ({ isCondition, tabInfo }) => {
  const navigate = useNavigate();
  const { product, setProduct, handleChange, inputError, setInputError, setHasMultiSelectCategoryMandatory, colourFile, setColourFile, swatchNotifyData: ctxSwatchNotifyData, setSwatchNotifyData: ctxSetSwatchNotifyData, validateProduct } = useContext(ProductContext);
  console.log(product, "prior")
  const B2B_API = createB2BAPI();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [width, setWidth] = useState({
    inches: '',
    centimeter: '',
    meter: '',
    meter_per_kg: '',
  });
  const [activeSwatch, setActiveSwatch] = useState(null);
  const [prevSwatchNotifyData, setPrevSwatchNotifyData] = useState({});
  const categoryInitialState = { key: '', value: {}, heirarchyLabel: '', options: [], openModal: false, count: 2, multiSelect: false };
  const [categorys, setCategorys] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [selectedPairsCategory, setSelectedPairsCategory] = useState([{ ...categoryInitialState }]);
  const [opened, { open, close }] = useDisclosure(false);
  const [multiSelect, setMultiselect] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [unique, setUnique] = useState([]);
  const [attributes, setAttributes] = useState({});
  const [selectedPairsVariant, setSelectedPairsVariant] = useState([{ key: '', values: [] }]);
  const [combinations, setCombinations] = useState([]);
  const [variants, setVariants] = useState([]);
  const [activeTab, setActiveTab] = useState('Transaction');
  const [expandedRows, setExpandedRows] = useState([]);
  const [productVariantMap, setProductVariantMap] = useState(new Map());
  const [existingPairs, setExistingPairs] = useState([]);
  const [existingPairsKeys, setExistingPairsKeys] = useState([]);
  const openRef = useRef(null);
  const isRowExpanded = (index) => expandedRows.includes(index);
  const [totalPercent, setTotalpercent] = useState(product?.totalProductPercent || 0);
  const [fabricContent, setFabricContent] = useState({});
  const [selectedPairsFabric, setSelectedPairsFabric] = useState([{ key: '', values: [], value: null }]);
  const [lastChild, setLastChild] = useState([]);
  const [fCCValue, setFCCValue] = useState('');
  const [fabricValue, setFabricValue] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const [localSwatchNotifyData, setLocalSwatchNotifyData] = useState({
    awbNumber: '',
    docNumber: '',
    courierName: '',
    swatchQuantity: '',
    dispatchDate: '',
    deliveryDate: '',
  });

  const swatchNotifyData = ctxSwatchNotifyData || localSwatchNotifyData;
  const setSwatchNotifyData = ctxSetSwatchNotifyData || setLocalSwatchNotifyData;

  const [isViewOnlySwatch, setIsViewOnlySwatch] = useState(false);

  const fetchSwatchNotifyData = async () => {
    const draftId = product?.draftProductId || product?.id;
    if (!draftId) {
      if (swatchNotifyData?.docNumber || swatchNotifyData?.courierName || swatchNotifyData?.awbNumber) {
        setIsViewOnlySwatch(true);
        setActiveSwatch("sent");
        return;
      }
      notify({
        error: true,
        success: false,
        title: "Draft Product ID not found",
      });
      return;
    }

    try {
      const res = await B2B_API.get(
        `swatchNotifyData/getByDraftProductId?draftProductId=${draftId}`,
        { throwHttpErrors: false }
      );

      if (!res.ok) {
        if (swatchNotifyData?.docNumber || swatchNotifyData?.courierName || swatchNotifyData?.awbNumber) {
          setIsViewOnlySwatch(true);
          setActiveSwatch("sent");
        }
        return;
      }

      const dataRes = await res.json();
      if (dataRes?.response) {
        const data = {
          awbNumber: dataRes.response.awbNumber || "",
          docNumber: dataRes.response.docNumber || "",
          courierName: dataRes.response.courierName || "",
          swatchQuantity: dataRes.response.swatchQuantity || "",
          dispatchDate: dataRes.response.dispatchDate
            ? new Date(dataRes.response.dispatchDate).toISOString().split("T")[0]
            : "",
          deliveryDate: dataRes.response.deliveryDate
            ? new Date(dataRes.response.deliveryDate).toISOString().split("T")[0]
            : "",
        };

        setPrevSwatchNotifyData(data);
        setSwatchNotifyData(data);

        setIsViewOnlySwatch(true);
        setActiveSwatch("sent");
      }
    } catch (error) {
      console.log("No swatch data found or error fetching", error);
    }
  };

  useEffect(() => {
    const existingData = product?.swatchNotifyData || product?.vendorProductInfo?.swatchNotifyData;
    if (existingData && (existingData.awbNumber || existingData.docNumber || existingData.courierName)) {
      const data = {
        awbNumber: existingData.awbNumber || "",
        docNumber: existingData.docNumber || "",
        courierName: existingData.courierName || "",
        swatchQuantity: existingData.swatchQuantity || "",
        dispatchDate: existingData.dispatchDate
          ? new Date(existingData.dispatchDate).toISOString().split("T")[0]
          : "",
        deliveryDate: existingData.deliveryDate
          ? new Date(existingData.deliveryDate).toISOString().split("T")[0]
          : "",
      };
      setPrevSwatchNotifyData(data);
      setSwatchNotifyData(data);
    }
  }, [product?.swatchNotifyData, product?.vendorProductInfo?.swatchNotifyData]);

  useEffect(() => {
    const updatedSelectedValues = {};
    const uniqueCategoryKeys = [...new Set(product.productCategoriesList?.map(category => category?.productGroupName))];
    uniqueCategoryKeys.forEach((category) => {
      const selectedForCategory = product.productCategoriesList
        .filter((item) => item.productGroupName === category)
        .map((item) => item.id) || [];
      updatedSelectedValues[category] = selectedForCategory;
    });
    setSelectedValues(updatedSelectedValues);
  }, [selectedPairsCategory]);
  const handleSwatchSample = async () => {
    if (!activeSwatch) return;

    try {
      let url = "";
      let successTitle = "";

      if (activeSwatch === "sent") {
        if (
          !swatchNotifyData.awbNumber?.trim() ||
          !swatchNotifyData.docNumber?.trim() ||
          !swatchNotifyData.courierName?.trim() ||
          !swatchNotifyData.swatchQuantity ||
          !swatchNotifyData.dispatchDate ||
          !swatchNotifyData.deliveryDate
        ) {
          notify({
            error: true,
            success: false,
            title: "All fields are mandatory",
          });
          return;
        }
        if (!swatchNotifyData.dispatchDate || !swatchNotifyData.deliveryDate) {
          notify({ error: true, success: false, title: "Dispatch Date and Delivery Date are required" });
          return;
        }

        const dispatch = new Date(swatchNotifyData.dispatchDate);
        const delivery = new Date(swatchNotifyData.deliveryDate);

        if (delivery < dispatch) {
          notify({ error: true, success: false, title: "Delivery Date should be after the Dispatch Date" });
          return;
        }

        const draftId = product?.draftProductId || product?.id;
        if (draftId) {
          url = `draftProduct/updateSwatchSent?id=${draftId}`;
          successTitle = "Swatch Sent successfully";

          const payload = {
            draftProductId: draftId,
            ...swatchNotifyData,
            swatchSent: true,
            swatchRequest: true,
            saveGe: false,
          };

          await B2B_API.post(`swatchNotifyData/create`, {
            json: payload,
            throwHttpErrors: false,
          });
          if (!product?.swatchSent && !product?.vendorProductInfo?.swatchSent) {
            await B2B_API.get(url, { throwHttpErrors: false });
          }
        }
      } else if (activeSwatch === "received") {
        const draftId = product?.draftProductId || product?.id;
        if (draftId) {
          url = `draftProduct/updateSwatchReceived?id=${draftId}`;
          successTitle = "Swatch marked as Received successfully";
          await B2B_API.get(url, { throwHttpErrors: false });
        }
      }

      setProduct((prev) => ({
        ...prev,
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          swatchSent: activeSwatch === "sent" ? true : prev.vendorProductInfo.swatchSent,
          swatchReceived: activeSwatch === "received" ? true : prev.vendorProductInfo.swatchReceived,
        },
        swatchSent: activeSwatch === "sent" ? true : prev.swatchSent,
        swatchRequest: activeSwatch === "sent" ? true : prev.swatchRequest,
        swatchReceived: activeSwatch === "received" ? true : prev.swatchReceived,
      }));

      setActiveSwatch(null);
      notify({
        error: false,
        success: true,
        title: "Swatch Details Saved",
      });
    } catch (error) {
      console.error("Error updating swatch:", error);

      notify({
        error: true,
        success: false,
        title: error?.message || "Something went wrong while updating swatch",
      });
    }
  };

  const handleDimensionChange = (event, unit, errorName) => {
    let newValue = event.target.value;
    setInputError((prev) => ({
      ...prev,
      [errorName]: '',
    }));

    if (newValue === '') {
      const newWidth = { inches: '', centimeter: '', meter: '', meter_per_kg: '' };
      setWidth(newWidth);
      setProduct((prevState) => {
        const updatedMetrics = {
          ...prevState.metrics,
          width: '',
          inches: 0,
          centimeter: 0,
          meter: 0,
          meterPerKg: '',
        };
        return {
          ...prevState,
          metrics: updatedMetrics,
        };
      });
      return;
    }

    newValue = parseFloat(newValue) || 0;
    const newWidth = { ...width };

    if (unit === 'inches') {
      newWidth.inches = newValue;
      newWidth.centimeter = (newValue * 2.54).toFixed(2);
      newWidth.meter = (newValue * 0.0254).toFixed(2);
    } else if (unit === 'centimeter') {
      newWidth.centimeter = newValue;
      newWidth.inches = (newValue / 2.54).toFixed(2);
      newWidth.meter = (newValue * 0.01).toFixed(2);
    } else if (unit === 'meter') {
      newWidth.meter = newValue;
      newWidth.inches = (newValue / 0.0254).toFixed(2);
      newWidth.centimeter = (newValue * 100).toFixed(2);
    }

    const weight = product.metrics?.weight || 1;
    const newMeterPerKg = newWidth.meter && weight ? (1000 / (newWidth.meter * weight)).toFixed(2) : '';
    newWidth.meter_per_kg = isNaN(newMeterPerKg) ? '' : newMeterPerKg;

    setWidth(newWidth);

    setProduct((prevState) => {
      const updatedMetrics = {
        ...prevState.metrics,
        width: newWidth.inches ? parseFloat(newWidth.inches) : prevState.metrics.width,
        inches: newWidth.inches ? parseFloat(newWidth.inches) : prevState.metrics.inches,
        centimeter: newWidth.centimeter ? parseFloat(newWidth.centimeter) : prevState.metrics.centimeter,
        meter: newWidth.meter ? parseFloat(newWidth.meter) : prevState.metrics.meter,
        meterPerKg: newWidth.meter_per_kg ? parseFloat(newWidth.meter_per_kg) : prevState.metrics.meterPerKg,
      };
      return {
        ...prevState,
        metrics: updatedMetrics,
      };
    });
  };


  const fetchCategories = async () => {
    try {
      const res = await B2B_API.get('product-category?status=ACTIVE').json();
      const categories = res?.response?.filter(cat => cat.name?.toLowerCase() === 'fabric type');
      const categoryName = categories.map(res => res.name);
      const mandatoryCategories = categories?.filter(cat => cat.isMandatory);
      const getLastChildCategories = (selectedKey) => {
        const childCategory = categories.find(cat => cat.name === selectedKey)?.child || [];
        return childCategory.reduce((acc, category) => {
          if (!category.child || category.child.length === 0) {
            acc.push({ ...category, value: category.id, label: category.name });
          } else {
            acc.push(...getLastChildCategories(category.child));
          }
          return acc;
        }, []);
      };
      categoryName.forEach(item => {
        setMultiselect(prev => ({ ...prev, [item]: getLastChildCategories(item) }));
      });
      setCategoryName(categoryName);
      setCategorys(categories);
      setCategorysAndselectedPairs(mandatoryCategories, categories);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const setCategorysAndselectedPairs = (mandatoryCategories = [], freshCategories = []) => {
    const availableCategories = freshCategories.length > 0 ? freshCategories : categorys;
    const productCategoriesList = product.productCategoriesList || [];
    let formattedCategories = [];
    const uniqueCategoryKeys = new Set();

    if (Array.isArray(product?.productCategories) && product.productCategories.length > 0) {
      formattedCategories = product.productCategories.map(category => {
        const currentCatConfig = availableCategories.find(cat => cat.name === category?.key);
        const hasSelectedValue = category?.heirarchyLabel ? true : false;
        return {
          ...categoryInitialState,
          options: category?.options?.length > 0 ? category.options : (hasSelectedValue ? [] : (currentCatConfig?.child || [])),
          key: category?.key,
          isMandatory: category?.isMandatory,
          heirarchyLabel: category.heirarchyLabel,
          value: category?.value,
        };
      });
    } else if (_.size(productCategoriesList) > 0) {
      _.forEach(productCategoriesList, prod => {
        if (!uniqueCategoryKeys.has(prod.productGroupName)) {
          uniqueCategoryKeys.add(prod.productGroupName);
          formattedCategories.push({
            ...categoryInitialState,
            heirarchyLabel: prod.name,
            key: prod.productGroupName,
            multiSelect: prod.multiSelect,
            isMandatory: mandatoryCategories.find(cat => cat.name === prod.productGroupName)?.isMandatory || false,
            options: availableCategories.find(cat => cat.name === prod.productGroupName)?.child || [],
          });
        }
      });
    }

    if (formattedCategories.length > 0) {
      formattedCategories.sort((a, b) => (b.isMandatory === true) - (a.isMandatory === true));
      setSelectedPairsCategory(formattedCategories);
      setProduct(prev => ({ ...prev, productCategories: formattedCategories.filter(cat => !cat.multiSelect) }));
    } else if (mandatoryCategories.length > 0 && productCategoriesList.length === 0) {
      formattedCategories = mandatoryCategories.map(category => ({
        ...categoryInitialState,
        options: category?.child || [],
        key: category.name,
        isMandatory: true,
        multiSelect: category.multiSelect,
      }));
      setSelectedPairsCategory(formattedCategories);
      setHasMultiSelectCategoryMandatory(mandatoryCategories);
      setProduct(prev => ({ ...prev, productCategories: formattedCategories.filter(cat => !cat.multiSelect) }));
    }
  };

  const handleSelectChangeCategory = (index, selectedKey) => {
    const newPairs = [...selectedPairsCategory];
    newPairs[index] = { ...categoryInitialState, key: selectedKey };
    const childCategory = categorys.filter(cat => cat.name === selectedKey)?.[0];
    if (!childCategory?.multiSelect) {
      setProduct(prev => ({ ...prev, productCategories: newPairs }));
    } else {
      newPairs[index].multiSelect = true;
    }
    newPairs[index].options = childCategory?.child || [];
    setSelectedPairsCategory(newPairs);
    setInputError('');
  };

  const openModals = (index, value) => {
    const newPairs = [...selectedPairsCategory];
    newPairs[index].openModal = value;
    setSelectedPairsCategory(newPairs);
  };

  const addNewPairCategory = () => {
    setSelectedPairsCategory([...selectedPairsCategory, { ...categoryInitialState }]);
  };

  const removePairCategory = (index, catname) => {
    const newPairs = [...selectedPairsCategory];
    newPairs.splice(index, 1);
    setSelectedPairsCategory(newPairs);
    if (catname) {
      setSelectedValues((prevState) => {
        const newState = { ...prevState };
        delete newState[catname];
        return newState;
      });
      const list = product?.productCategoriesList?.filter(item => item.productGroupName !== catname);
      setProduct((prevProduct) => ({
        ...prevProduct,
        productCategoriesList: list,
      }));
    }
    setProduct(prev => ({ ...prev, productCategories: (newPairs || []).filter(cat => !cat.multiSelect) }));
  };

  const selectCategory = (index, cat) => {
    const newPairs = [...selectedPairsCategory];
    const label = newPairs[index]?.heirarchyLabel;
    newPairs[index].value = cat || {};
    const hasNoChild = _.size(cat?.child) === 0;
    if (cat) {
      if (hasNoChild) {
        const splitLabel = label.split(' / ');
        if (splitLabel.length === (newPairs[index].count - 1)) {
          splitLabel[splitLabel.length - 1] = cat.name;
          newPairs[index].heirarchyLabel = _.join(splitLabel, ' / ');
        } else {
          newPairs[index].heirarchyLabel = label.concat(label ? ' / ' : '').concat(cat.name);
        }
        newPairs[index].openModal = false;
        newPairs[index].lastChildName = cat.name;
        setProduct(prev => ({ ...prev, productCategories: (newPairs || []).filter(cat => !cat.multiSelect) }));
      } else {
        newPairs[index].heirarchyLabel = label.concat(label ? ' / ' : '').concat(cat.name);
        let count = newPairs[index].count;
        newPairs[index].count = ++count;
        newPairs[index].options = cat.child;
      }
    } else {
      newPairs[index].heirarchyLabel = '';
      newPairs[index].count = 2;
      newPairs[index].options = getParentChild(newPairs[index].key);
    }
    setSelectedPairsCategory(newPairs);
    setInputError('');
  };

  const removeCategory = (index) => {
    openModals(index, false);
    selectCategory(index, null);
  };

  const getParentChild = (key) => {
    const childCategory = categorys.find(cat => cat.name === key)?.child || [];
    return childCategory;
  };

  const getAvailableKeysCategory = (currentIndex, catkey) => {
    const selectedKeys = selectedPairsCategory.map(pair => pair.key);
    return categoryName.filter(key => !selectedKeys.includes(key) || key === catkey || selectedPairsCategory[currentIndex].key === key);
  };

  useEffect(() => {
    const keyValuePairs = product.productVariants.map((productVariant) => {
      const filteredVariants = productVariant.variants.filter(variant => variant.name !== 'Solid / Pattern');
      return filteredVariants.map(variant => ({
        [variant.name]: variant.value,
      }));
    })
      .reduce((acc, objArray) => {
        objArray.forEach(obj => {
          const [key, value] = Object.entries(obj)[0];
          if (acc[key]) {
            acc[key] = [...new Set([...acc[key], value])];
          } else {
            acc[key] = [value];
          }
        });
        return acc;
      }, {});
    setExistingPairs(keyValuePairs);
    const existingKeys = product.productVariants.map(productVariant => productVariant.variants.map(variant => variant.name)).flat();
    const uniqueKeys = [...new Set(existingKeys)];
    setExistingPairsKeys(uniqueKeys);
  }, [product.id]);

  useEffect(() => {
    fetchVariants();
  }, []);

  useEffect(() => {
    generateProductVariantMap();
  }, [product?.productVariants]);

  useEffect(() => {
    updateCombinations(selectedPairsVariant);
  }, [variants, selectedPairsVariant]);

  const generateCombinations = (lists, variants = []) => {
    const result = [];
    const generateCombinationsRecursive = (depth, current) => {
      if (depth === lists.length) {
        result.push([...current]);
        return;
      }
      for (const element of lists[depth]) {
        current.push(element);
        generateCombinationsRecursive(depth + 1, current);
        current.pop();
      }
    };
    generateCombinationsRecursive(0, []);
    return result;
  };

  const generateProductVariantMap = () => {
    if (product.productVariants && _.size(product.productVariants) > 0 && _.size(product.productVariants[0].variants) > 0) {
      const productMap = new Map();
      _.map(product.productVariants, pv => {
        const variantIds = _.map(pv.variants, va => va.variantId || va.id);
        const sortedVariantIds = _.sortBy(variantIds);
        productMap.set(JSON.stringify(sortedVariantIds), pv);
      });
      setProductVariantMap(productMap);
    }
  };

  const findMatchingVariant = (combination) => {
    for (let i = 0; i < combination.length; i++) {
      const partialCombination = _.slice(combination, 0, i + 1);
      const flattenedCombination = _.flatten(partialCombination);
      const sortedFlattenedCombination = _.sortBy(flattenedCombination);
      const key = JSON.stringify(sortedFlattenedCombination);
      if (productVariantMap.has(key)) {
        const variant = productVariantMap.get(key);
        productVariantMap.delete(key);
        return variant;
      }
    }
    return null;
  };

  const updateCombinations = async (pairs) => {
    const hasAnyKey = pairs && pairs.some(pair => Boolean(pair.key));
    const hasSelectedPairs = pairs && pairs.some(pair => pair.key && pair.values && pair.values.length > 0);
    if (!hasSelectedPairs) {
      if (hasAnyKey) {
        setCombinations([]);
        setProduct(prev => ({
          ...prev,
          newProductVariants: []
        }));
        return;
      }
      const existingVariants = (Array.isArray(product?.newProductVariants) && product.newProductVariants.length > 0)
        ? product.newProductVariants
        : (Array.isArray(product?.productVariants) && product.productVariants.length > 0)
          ? product.productVariants
          : [];
      setCombinations(existingVariants);
      if (existingVariants.length > 0) {
        setProduct(prev => ({
          ...prev,
          newProductVariants: (Array.isArray(prev.newProductVariants) && prev.newProductVariants.length > 0)
            ? prev.newProductVariants
            : existingVariants,
        }));
      }
      return;
    }

    const newCombinations = generateCombinations(pairs.map(pair => pair.values), variants);
    const prodVariants = [];
    setCombinations(newCombinations);
    _.forEach(newCombinations, combination => {
      let variant = findMatchingVariant(combination);
      if (variant === null) {
        variant = {};
      }
      variant['variants'] = _.map(combination, c => {
        const masterV = _.find(variants, v => v.id === c || v.variantId === c || v.value === c);
        const origV = _.find(variant.variants || [], ov => (ov.variantId || ov.id) === c);
        if (origV && origV.variantId) {
          return { ...masterV, id: origV.variantId && origV.id !== origV.variantId ? origV.id : masterV.id, variantId: origV.variantId };
        }
        return { ...masterV, variantId: masterV.id };
      });
      variant['status'] = variant.id ? variant.status : 'ACTIVE';
      variant['name'] = `${product.articleName || "Product"} / ${getVarinatname(variant?.variants)}`;
      prodVariants.push(variant);
    });
    setProduct(prev => ({
      ...prev,
      newProductVariants: prodVariants,
    }));
    generateProductVariantMap();
  };

  const fetchVariants = async () => {
    try {
      const response = await B2B_API.get('variant').json();
      const groupedVariants = _.groupBy(response.response, 'name');
      setAttributes(groupedVariants);
      setVariants(response.response);
      setSelectedPairsFromProduct(response.response);
    } catch (error) {
      console.error('Error fetching variants:', error);
    }
  };

  const setSelectedPairsFromProduct = (masterVariantsList = variants) => {
    const prodVariants = {};

    const existingVariants = Array.isArray(product?.productVariants) && product.productVariants.length > 0
      ? product.productVariants
      : Array.isArray(product?.newProductVariants) && product.newProductVariants.length > 0
        ? product.newProductVariants
        : [];

    if (existingVariants.length > 0) {
      existingVariants.forEach(pv => {
        if (Array.isArray(pv.variants) && pv.variants.length > 0) {
          pv.variants.forEach(v => {
            if (v.name) {
              if (!prodVariants[v.name]) {
                prodVariants[v.name] = [];
              }
              const mv = masterVariantsList?.find(m => m.id === v.id || m.variantId === v.variantId || (v.variantId && m.id === v.variantId) || (v.id && m.variantId === v.id) || (m.name === v.name && m.value === v.value));
              const targetId = mv ? mv.id : (v.id || v.variantId);
              if (targetId && !prodVariants[v.name].includes(targetId)) {
                prodVariants[v.name].push(targetId);
              }
            }
          });
        } else if (pv.name && masterVariantsList && masterVariantsList.length > 0) {
          let variantString = pv.name;
          if (product.articleName && variantString.startsWith(product.articleName + " / ")) {
            variantString = variantString.substring((product.articleName + " / ").length);
          } else {
            const parts = variantString.split(' / ');
            if (parts.length > 1) {
              variantString = parts.slice(1).join(' / ');
            }
          }
          const nameParts = variantString.split(' / ').map(s => s.trim()).filter(Boolean);
          masterVariantsList.forEach(mv => {
            if (mv.name && mv.value && mv.id) {
              if (nameParts.includes(mv.value) || variantString === mv.value) {
                if (!prodVariants[mv.name]) {
                  prodVariants[mv.name] = [];
                }
                if (!prodVariants[mv.name].includes(mv.id)) {
                  prodVariants[mv.name].push(mv.id);
                }
              }
            }
          });
        }
      });
    }

    const keys = Object.keys(prodVariants);
    if (_.size(keys) > 0) {
      const pairs = keys.map(key => ({
        key,
        values: Array.from(new Set(prodVariants[key])),
      }));
      setSelectedPairsVariant(pairs);
      setProduct(prev => ({
        ...prev,
        prodVariants: prodVariants,
      }));
    }
  };

  useEffect(() => {
    if (variants && variants.length > 0 && (product?.productVariants?.length > 0 || product?.newProductVariants?.length > 0)) {
      setSelectedPairsFromProduct(variants);
    }
  }, [product?.id, product?.productVariants, variants]);

  const handleSelectChangeVariant = (index, selectedValue) => {
    const newPairs = [...selectedPairsVariant];
    const oldKey = newPairs[index].key;
    newPairs[index].key = selectedValue || '';
    if (!selectedValue) {
      newPairs[index].values = [];
    }
    const newKey = newPairs[index].key;
    if (newKey !== oldKey) {
      newPairs[index].key = selectedValue;
      newPairs[index].values = [];
    }
    setSelectedPairsVariant(newPairs);
    const updatedProdVariants = { ...product.prodVariants };
    if (oldKey && oldKey !== selectedValue) {
      delete updatedProdVariants[oldKey];
    }
    if (selectedValue) {
      updatedProdVariants[selectedValue] = newPairs[index].values || [];
    }
    setProduct(prevState => ({ ...prevState, prodVariants: updatedProdVariants }));
    updateCombinations(newPairs);
  };

  const handleMultiSelectChangeVariant = (index, selectedValues) => {
    const newPairs = [...selectedPairsVariant];
    newPairs[index].values = selectedValues;
    const updatedProdVariants = { ...product.prodVariants };
    updatedProdVariants[newPairs[index].key] = selectedValues;
    setSelectedPairsVariant(newPairs);
    setProduct(prev => ({ ...prev, prodVariants: updatedProdVariants }));
    updateCombinations(newPairs);
    setInputError(prev => {
      const variantPairs = Array.isArray(prev.variantPairs) ? [...prev.variantPairs] : [];
      variantPairs[index] = '';
      return { ...prev, variantPairs };
    });
  };

  const handleSelectSolidChange = (index, selectedValue) => {
    const newPairs = [...selectedPairsVariant];
    newPairs[index].values = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
    const updatedProdVariants = { ...product.prodVariants };
    updatedProdVariants[newPairs[index].key] = newPairs[index].values;
    setSelectedPairsVariant(newPairs);
    setProduct(prev => ({ ...prev, prodVariants: updatedProdVariants }));
    updateCombinations(newPairs);
  };

  const addNewPairVariant = () => {
    const newPairs = [...selectedPairsVariant, { key: '', values: [] }];
    setSelectedPairsVariant(newPairs);
    const newCombinations = [{ ...selectedPairsVariant[0], values: [] }, ...combinations];
    setCombinations(newCombinations);
    updateCombinations(newPairs);
  };

  const removePairVariant = (index) => {
    const newPairs = [...selectedPairsVariant];
    const removedPairKey = newPairs[index].key;
    newPairs.splice(index, 1);
    setSelectedPairsVariant(newPairs);
    const updatedProdVariants = { ...product.prodVariants };
    delete updatedProdVariants[removedPairKey];
    setProduct(prev => ({ ...prev, prodVariants: updatedProdVariants }));
    updateCombinations(newPairs);
  };

  const getAvailableKeysVariant = (currentIndex) => {
    const selectedKeys = selectedPairsVariant.map(pair => pair.key);
    return Object.keys(attributes).filter(key => !selectedKeys.includes(key) || selectedPairsVariant[currentIndex].key === key);
  };

  const handleToggle = (index) => {
    if (expandedRows.includes(index)) {
      setExpandedRows(expandedRows.filter((i) => i !== index));
    } else {
      setExpandedRows([index]);
    }
  };

  const handleTransaction = (index, key, event) => {
    setProduct((prevProduct) => ({
      ...prevProduct,
      newProductVariants: prevProduct.newProductVariants.map((variant, i) => {
        if (i === index) {
          return {
            ...variant,
            [key]: 'true' === event?.target?.value,
          };
        }
        return { ...variant };
      }),
    }));
  };

  const handleEnable = (index) => {
    setProduct((prevProduct) => ({
      ...prevProduct,
      newProductVariants: prevProduct.newProductVariants.map((variant, i) => {
        if (i === index) {
          return {
            ...variant,
            status: variant.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
          };
        }
        return variant;
      }),
    }));
  };

  const getVarinatname = (variants) => {
    return variants.filter(v => v && v.value).map(v => v.value).join(" / ");
  };

  const json = [
    {
      label: 'Stop GRN',
      type: 'radio',
      key: 'isStopGRN',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isStopGRN', event),
      name: 'isStopGRN',
    },
    {
      label: 'Stop Purchase Return',
      type: 'radio',
      key: 'isStopPurchaseReturn',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isStopPurchaseReturn', event),
      name: 'isStopPurchaseReturn',
    },
    {
      label: 'Stop Sale',
      type: 'radio',
      key: 'isStopSale',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'Metadata', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isStopSale', event),
      name: 'isStopSale',
    },
    {
      label: 'Allow Refund',
      type: 'radio',
      key: 'isAllowRefund',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isAllowRefund', event),
      name: 'isAllowRefund',
    },
    {
      label: 'Allow Negative',
      type: 'radio',
      key: 'isAllowNegative',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isAllowNegative', event),
      name: 'isAllowNegative',
    },
    {
      label: 'Allow Cost Edit',
      type: 'radio',
      key: 'isAllowCostEditInGRN',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isAllowCostEditInGRN', event),
      name: 'isAllowCostEditInGRN',
    },
    {
      label: 'Enable Serial Number',
      type: 'radio',
      key: 'isEnableSerialNumber',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isEnableSerialNumber', event),
      name: 'isEnableSerialNumber',
    },
    {
      label: 'Non-trading',
      type: 'radio',
      key: 'isNonTrading',
      fieldType: 'radioField',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      onChange: (index, event) => handleTransaction(index, 'isNonTrading', event),
      name: 'isNonTrading',
    },
  ];

  useEffect(() => {
    fetchFabricContent();
    setFCCValue(product?.fabricContent?.value);
    getFabricValues();
  }, []);

  useEffect(() => {
    if (fabricContent) {
      const emptyNodes = findEmptyChildNodes(fabricContent);
      setLastChild(emptyNodes);
    }
  }, [fabricContent]);

  const fetchFabricContent = async () => {
    try {
      const res = await B2B_API.get('product-category?status=ACTIVE').json();
      const categories = res.response;
      const category = categories.find(cat => cat.name === 'Fabric Content');
      setFabricContent(category);
      setSelectedPairsFromProductFabric();
    } catch (error) {
      console.error('Error fetching fabric content:', error);
    }
  };

  const setSelectedPairsFromProductFabric = () => {
    const { fabricContent } = product;
    const keys = Object.keys(fabricContent?.composition);
    if (_.size(keys) > 0) {
      setSelectedPairsFabric(_.map(keys, key => ({
        key,
        value: fabricContent?.composition[key],
      })));
    }
  };

  function findEmptyChildNodes(node) {
    const result = [];
    function traverse(node) {
      if (node && node.child && node.child.length === 0) {
        result.push(node);
      }
      if (node && node.child) {
        node.child.forEach(traverse);
      }
    }
    traverse(node);
    return result;
  }

  const keyToNameMap = lastChild.reduce((map, item) => {
    map[item.categoryId] = item.name;
    return map;
  }, {});

  const getAvailableKeysFabric = (currentIndex) => {
    const selectedKeys = selectedPairsFabric.map(pair => pair.key);
    return Object.keys(keyToNameMap).filter(key => !selectedKeys.includes(key) || selectedPairsFabric[currentIndex].key === key);
  };

  const fabricContentCode = async (newPairs) => {
    try {
      const results = await Promise.all(
        Object.entries(newPairs).map(async ([key, value]) => {
          const res = await B2B_API.get(`product-category/category/${key}`).json();
          const name = res.response.name;
          const fcc = name.substring(0, 3).toUpperCase();
          return `${fcc}-${value}%`;
        })
      );
      const formattedFCC = results.join(' ');
      setProduct(prevState => ({
        ...prevState,
        fabricContent: {
          ...prevState.fabricContent,
          value: formattedFCC,
        },
      }));
      setFCCValue(formattedFCC);
    } catch (error) {
      console.error('Error fetching category data: ', error);
    }
  };

  const handleSelectChangeFabric = (index, selectedValue) => {
    const newPairs = [...selectedPairsFabric];
    const oldKey = newPairs[index].key;
    const oldValue = parseInt(newPairs[index].value, 10) || 0;
    newPairs[index].key = selectedValue || '';
    newPairs[index].value = selectedValue ? newPairs[index].value : '';
    const newValue = parseInt(newPairs[index].value, 10) || 0;
    const updatedTotal = totalPercent - oldValue + newValue;
    setTotalpercent(updatedTotal);
    setSelectedPairsFabric(newPairs);
    setProduct(prevState => {
      const updatedComposition = { ...prevState.fabricContent.composition };
      if (oldKey && oldKey !== selectedValue) {
        delete updatedComposition[oldKey];
      }
      if (selectedValue) {
        updatedComposition[selectedValue] = newPairs[index].value || 0;
      }
      return {
        ...prevState,
        totalProductPercent: updatedTotal,
        fabricContent: {
          ...prevState.fabricContent,
          composition: updatedComposition,
        },
      };
    });

    const pairsObject = newPairs.reduce((acc, pair) => {
      if (pair.key && pair.value) {
        acc[pair.key] = pair.value;
      }
      return acc;
    }, {});

    if (Object.keys(pairsObject).length > 0) {
      fabricContentCode(pairsObject);
      setFCCValue(prev => {
        const existingValues = prev ? prev.split(' ') : [];
        const newValues = Object.entries(pairsObject).map(([key, value]) => {
          const fcc = keyToNameMap[key]?.substring(0, 3).toUpperCase() || '';
          return `${fcc}-${value}%`;
        });
        const updatedValues = [...new Set([...existingValues, ...newValues])].join(' ');
        return updatedValues;
      });
    } else {
      setFCCValue('');
      setProduct(prevState => ({
        ...prevState,
        fabricContent: {
          ...prevState.fabricContent,
          value: '',
        },
      }));
    }
    setInputError(prev => ({
      ...prev,
      fabricCompositionError: false,
      fabricContentError: false,
      fabricContentErrorMessage: '',
    }));
  };

  const handleMultiSelectChangeFabric = (index, value) => {
    const newPairs = [...selectedPairsFabric];
    const key = newPairs[index].key;
    const previousValue = parseInt(newPairs[index].value, 10) || 0;
    const updatedTotal = totalPercent - previousValue + value;
    if (key) {
      newPairs[index].value = value;
      setSelectedPairsFabric(newPairs);
      setTotalpercent(updatedTotal);
      setProduct(prevState => ({
        ...prevState,
        totalProductPercent: updatedTotal,
        fabricContent: {
          ...prevState.fabricContent,
          composition: {
            ...prevState.fabricContent.composition,
            [key]: value,
          },
        },
      }));
      const pairsObject = newPairs.reduce((acc, pair) => {
        if (pair.key && pair.value) {
          acc[pair.key] = pair.value;
        }
        return acc;
      }, {});
      fabricContentCode(pairsObject);
    }
    setInputError(prev => ({
      ...prev,
      fabricCompositionError: false,
      fabricContentError: false,
      fabricContentErrorMessage: '',
    }));
  };

  const addNewPairFabric = () => {
    const totalSum = _.sumBy(selectedPairsFabric, (item) => parseInt(item.value));
    if (totalSum < 100) {
      setSelectedPairsFabric([...selectedPairsFabric, { key: '', value: '' }]);
      setInputError(prev => ({
        ...prev,
        fabricCompositionError: false,
        fabricContentError: false,
        fabricContentErrorMessage: '',
      }));
    }
  };

  const removePairFabric = (index, value) => {
    const newPairs = [...selectedPairsFabric];
    const removedKey = newPairs[index].key;
    const updatedTotal = totalPercent - value;
    setTotalpercent(updatedTotal);
    newPairs.splice(index, 1);
    setSelectedPairsFabric(newPairs);
    const pairsObject = newPairs.reduce((acc, pair) => {
      if (pair.key && pair.value) {
        acc[pair.key] = pair.value;
      }
      return acc;
    }, {});
    fabricContentCode(pairsObject);
    setProduct(prevState => {
      const { [removedKey]: _, ...newComposition } = prevState.fabricContent?.composition;
      return {
        ...prevState,
        totalProductPercent: updatedTotal,
        fabricContent: {
          ...prevState.fabricContent,
          composition: newComposition,
          value: fCCValue,
        },
      };
    });
  };

  const getFabricValues = async () => {
    try {
      const res = await B2B_API.get(`fabric?status=ACTIVE`).json();
      setFabricValue(res?.response);
    } catch (error) {
      console.error('Error fetching fabric values: ', error);
    }
  };

  const ChangeHandlerFabric = (selectedValue) => {
    const selectedFabric = fabricValue.find(fabric => fabric.value === selectedValue);
    const compositionArray = Object.entries(selectedFabric.composition);

    const pair = selectedFabric && selectedFabric.value
      ? selectedFabric.value.split(' ').reduce((acc, item) => {
        const [key, value] = item.split('-');
        acc.push(parseInt(value));
        return acc;
      }, [])
      : [];

    const valueOrderMap = pair.reduce((acc, value, index) => {
      acc[value] = index;
      return acc;
    }, {});

    const selectedPairs = compositionArray.sort((a, b) => {
      return valueOrderMap[a[1]] - valueOrderMap[b[1]];
    });
    setSelectedPairsFabric(selectedPairs.map(([key, value]) => ({ key, value })));
    const totalSum = selectedPairs.reduce((sum, [_, value]) => sum + parseInt(value, 10) || 0, 0);
    setTotalpercent(totalSum);
    const pairsObject = selectedPairs.reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
    if (Object.keys(pairsObject).length > 0) {
      setProduct(prevState => ({
        ...prevState,
        totalProductPercent: totalSum,
        fabricContent: {
          ...prevState.fabricContent,
          composition: pairsObject,
        },
      }));
      fabricContentCode(pairsObject);
    } else {
      setFCCValue('');
      setSelectedPairsFabric([{ key: '', values: [], value: null }]);
      setProduct(prevState => ({
        ...prevState,
        totalProductPercent: 0,
        fabricContent: {
          ...prevState.fabricContent,
          composition: {},
          value: '',
        },
      }));
    }
    setInputError(prev => ({
      ...prev,
      fabricCompositionError: false,
      fabricContentError: false,
      fabricContentErrorMessage: '',
    }));
  };

  const ifApproval = tabInfo === "Un Approved" ? true : false;

  return (
    <>
      <Modal
        opened={!!activeSwatch}
        title={
          isViewOnlySwatch
            ? "Swatch Sent Details"
            : activeSwatch === "sent"
              ? "Confirm Swatch Sent"
              : "Confirm Swatch Received"
        }
        onClose={() => {
          setActiveSwatch(null);
          setIsViewOnlySwatch(false);
          setSwatchNotifyData({
            awbNumber: '',
            docNumber: '',
            courierName: '',
            swatchQuantity: '',
            dispatchDate: '',
            deliveryDate: '',
          });
        }}>
        <div>

          {activeSwatch === "sent" && (
            <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "20px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>AWB Number <span style={{ color: "red" }}>*</span></label>
                <B2BInput
                  type="text"
                  placeholder="Enter AWB Number"
                  value={swatchNotifyData.awbNumber}
                  required
                  disabled={isViewOnlySwatch}
                  onChange={(e) =>
                    setSwatchNotifyData((prev) => ({
                      ...prev,
                      awbNumber: e.target.value,
                    }))
                  }
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Doc Number <span style={{ color: "red" }}>*</span></label>
                <B2BInput
                  type="text"
                  placeholder="Enter Doc Number"
                  value={swatchNotifyData.docNumber}
                  required
                  disabled={isViewOnlySwatch}
                  onChange={(e) =>
                    setSwatchNotifyData((prev) => ({
                      ...prev,
                      docNumber: e.target.value,
                    }))
                  }
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Courier Name <span style={{ color: "red" }}>*</span></label>
                <B2BInput
                  type="text"
                  placeholder="Enter Courier Name"
                  value={swatchNotifyData.courierName}
                  required
                  disabled={isViewOnlySwatch}
                  onChange={(e) =>
                    setSwatchNotifyData((prev) => ({
                      ...prev,
                      courierName: e.target.value,
                    }))
                  }
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Swatch Qty <span style={{ color: "red" }}>*</span></label>
                <B2BInput
                  type="text"
                  placeholder="Enter Swatch Qty"
                  value={swatchNotifyData.swatchQuantity}
                  required
                  disabled={isViewOnlySwatch}
                  onChange={(e) =>
                    setSwatchNotifyData((prev) => ({
                      ...prev,
                      swatchQuantity: e.target.value,
                    }))
                  }
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Dispatch Date <span style={{ color: "red" }}>*</span></label>
                <B2BInput
                  type="date"
                  value={swatchNotifyData.dispatchDate}
                  disabled={isViewOnlySwatch}
                  required
                  onChange={(e) =>
                    setSwatchNotifyData((prev) => ({
                      ...prev,
                      dispatchDate: e.target.value,
                    }))
                  }
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Delivery Date <span style={{ color: "red" }}>*</span></label>
                <B2BInput
                  type="date"
                  value={swatchNotifyData.deliveryDate}
                  disabled={isViewOnlySwatch}
                  required
                  onChange={(e) =>
                    setSwatchNotifyData((prev) => ({
                      ...prev,
                      deliveryDate: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
          )}
          <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            {isViewOnlySwatch ? (
              <Button
                onClick={() => {
                  setActiveSwatch(null);
                  setIsViewOnlySwatch(false);
                  setSwatchNotifyData({
                    awbNumber: '',
                    docNumber: '',
                    courierName: '',
                    swatchQuantity: '',
                    dispatchDate: '',
                    deliveryDate: '',
                  });
                }}
                style={{ backgroundColor: "#8BC53F" }}
              >
                Close
              </Button>
            ) : (
              <>
                {/* Cancel → keeps it unchecked */}
                <Button
                  onClick={() => setActiveSwatch(null)} // just close modal
                  style={{ backgroundColor: "red" }} // <-- put style here
                >
                  Cancel
                </Button>

                {/* Save → confirms checked */}
                <Button
                  onClick={handleSwatchSample}
                  style={{ backgroundColor: "#8BC53F" }} // <-- put style here
                >
                  Confirm
                </Button>
              </>
            )}
          </div>
        </div>
      </Modal>
      <div className="pm-container">
        <form className="pm-form">

          <div className="pm-swatch-details-section" style={{ border: "1px solid #675f5f3a", padding: "1rem", borderRadius: "5px", marginBottom: "1.5rem", marginTop: "0.5rem" }}>
            <h4 style={{ margin: "0 0 12px 0", fontWeight: "bold", fontSize: "16px", color: "#333" }}>Swatch Details</h4>
            <Grid gutter="xs" className="pm-dimensions-grid">
              <Grid.Col span={6} className="pm-dimension-col">
                <div className="pm-dimension-group">

                  <div className="pm-dimension-label">
                    <label style={{ width: "max-content", fontWeight: "bold" }}>
                      USSID <span className="pm-error-message">*</span>
                    </label>
                  </div>

                  <B2BInput
                    type="text"
                    placeholder="Enter USSID"
                    value={product?.vendorProductInfo?.ussId || product?.ussId || ""}
                    onChange={(event) =>
                      handleChange(event, "vendorProductInfo.ussId", "ussIdErrorMessage")
                    }
                    disabled={true}
                    className="pm-dimension-input"
                  />

                  {inputError?.ussIdErrorMessage && (
                    <span className="pm-error-message">
                      {inputError.ussIdErrorMessage}
                    </span>
                  )}

                </div>
              </Grid.Col>

              <Grid.Col span={3} className="pm-dimension-col">
                <div className="pm-dimension-group">

                  <div className="pm-dimension-label">
                    <label style={{ width: "max-content", fontWeight: "bold" }}>Swatch Received</label>
                  </div>

                  <Checkbox
                    checked={product?.swatchReceived ?? false}
                    disabled={true}
                    color="#8BC53F"
                  />

                </div>
              </Grid.Col>

              <Grid.Col span={3} className="pm-dimension-col">
                <div className="pm-dimension-group">

                  <div className="pm-dimension-label">
                    <label style={{ width: "max-content", fontWeight: "bold" }}>Swatch Sent</label>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Checkbox
                      checked={product?.swatchSent ?? false}
                      onChange={() => {
                        if (!product?.swatchSent) {
                          setActiveSwatch("sent");
                        }
                      }}
                      disabled={product?.swatchSent === true}
                      color="#8BC53F"
                    />
                    {(product?.swatchSent ?? false) && (
                      <IconEye
                        size={20}
                        color="#8BC53F"
                        style={{ cursor: 'pointer', transition: 'color 0.2s' }}
                        title="View Swatch Details"
                        onClick={fetchSwatchNotifyData}
                      />
                    )}
                  </div>

                </div>
              </Grid.Col>
            </Grid>
          </div>

          <Grid gutter="xs" className="pm-dimensions-grid">
            {!Boolean(product?.orderDriven) && (
              <Grid.Col span={6} className="pm-dimension-col">
                <div className="pm-dimension-group">

                  <div className="pm-dimension-label">
                    <label style={{ width: "max-content" }}>
                      Color Variant Idea
                    </label>
                  </div>

                  {/* File input / view existing file */}
                  {(() => {
                    const existingFileUrl = typeof product?.colourVaraint === "string" && product.colourVaraint.trim() ? product.colourVaraint
                      : typeof product?.vendorProductInfo?.colourVaraint === "string" && product.vendorProductInfo.colourVaraint.trim() ? product.vendorProductInfo.colourVaraint
                        : Array.isArray(product?.standardtcolourimage) && product.standardtcolourimage.length > 0 && typeof product.standardtcolourimage[0] === "string" && product.standardtcolourimage[0].trim() ? product.standardtcolourimage[0]
                          : Array.isArray(product?.vendorProductInfo?.standardtcolourimage) && product.vendorProductInfo.standardtcolourimage.length > 0 && typeof product.vendorProductInfo.standardtcolourimage[0] === "string" && product.vendorProductInfo.standardtcolourimage[0].trim() ? product.vendorProductInfo.standardtcolourimage[0]
                            : null;

                    return (
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{ flex: 1 }}>
                          <Input
                            type="file"
                            className="pm-dimension-input"
                            onChange={(event) => {
                              const selectedFile = event.target.files[0];
                              if (selectedFile) {
                                const maxSizeBytes = 10 * 1024 * 1024; // 10MB
                                if (selectedFile.size > maxSizeBytes) {
                                  notify({ error: true, success: false, title: "File size must be less than 10MB" });
                                  event.target.value = '';
                                  setColourFile(null);
                                  return;
                                }
                                setColourFile(selectedFile);
                              }
                            }}
                          />
                          <span style={{ fontSize: "11px", color: "#888", display: "block", marginTop: "2px" }}>(Max file size: 10MB)</span>
                        </div>
                        {colourFile && typeof colourFile !== "string" && (
                          <a
                            href={URL.createObjectURL(colourFile)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#8BC53F",
                              textDecoration: "underline",
                              fontSize: "13px",
                              fontWeight: 600,
                              whiteSpace: "nowrap"
                            }}
                          >
                            View uploaded file
                          </a>
                        )}
                        {!colourFile && existingFileUrl && (
                          <a
                            href={existingFileUrl.startsWith("http") ? existingFileUrl : `${BASE_URL}${existingFileUrl.replace("/api", "")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#007bff",
                              textDecoration: "underline",
                              fontSize: "13px",
                              fontWeight: 600,
                              whiteSpace: "nowrap"
                            }}
                          >
                            View existing file
                          </a>
                        )}
                      </div>
                    );
                  })()}

                </div>
              </Grid.Col>
            )}
          </Grid>
          <Grid >

            <Grid.Col span={6} className="pm-dimension-col pm-hidden">
              <div className="pm-dimension-group">
                <div className="pm-dimension-label">
                  <label style={{ width: "max-content" }}>Cone Weight (grms) <span className="pm-error-message">*</span></label>
                </div>
                <div className="pm-input-wrapper">
                  <B2BInput
                    type="text"
                    placeholder="In grm"
                    value={product?.otherInformation?.coneWeight || ''}
                    onChange={(e) => handleChange(e, "coneWeight", "coneWeightError")}
                    disabled={isCondition}
                    className="pm-dimension-input"
                  />
                  {inputError?.coneWeightErrorMessage && (
                    <span className="pm-error-message">{inputError.coneWeightErrorMessage}</span>
                  )}
                </div>
              </div>
            </Grid.Col>
            {console.log(selectedPairsCategory, "slkslksl")}

            {/* Category Section */}
            {selectedPairsCategory.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid.Col span={6} className="pm-category-col">
                  <div className="pm-category-row">
                    <div className="pm-category-label">
                      <label style={{ width: "max-content" }}>Category <span className="pm-error-message">*</span></label>
                    </div>
                    <div className="pm-input-wrapper">
                      <B2BSelect
                        value={pair.key}
                        data={getAvailableKeysCategory(index)}
                        onChange={(e) => handleSelectChangeCategory(index, e)}
                        error={inputError[index]?.categoryErrorMessage}
                        className="pm-category-input"
                        disabled={isCondition}
                      />
                    </div>
                  </div>
                </Grid.Col>

                <Grid.Col span={6} className="pm-category-col">
                  <div className="pm-category-row">
                    <div className="pm-category-label">
                      <label style={{ width: "max-content" }}>Level <span className="pm-error-message">*</span></label>
                    </div>
                    <div className="pm-input-wrapper">
                      {!pair.multiSelect ? (
                        <div className="pm-category-input">
                          <input
                            placeholder="Select a category"
                            disabled={isCondition}
                            style={{ cursor: pair.key === null ? 'not-allowed' : 'pointer' }}
                            readOnly
                            type="text"
                            value={pair.heirarchyLabel}
                            onClick={() => openModals(index, true)}
                            onChange={() => { }}
                          />
                        </div>
                      ) : (
                        <div>
                          <MultiSelect
                            data={multiSelect[pair.key]?.map((item) => ({ value: item.id, label: item.name }))}
                            value={selectedValues[pair.key]}
                            disabled={isCondition || pair.key === null}
                            onChange={(newSelectedValues) => {
                              const categoryKey = pair.key;
                              setSelectedValues((prevValues) => {
                                const updatedValues = {
                                  ...prevValues,
                                  [categoryKey]: newSelectedValues,
                                };
                                const list = product?.productCategoriesList?.filter(item => item?.productGroupName !== categoryKey) || [];
                                setProduct((prevProduct) => ({
                                  ...prevProduct,
                                  productCategoriesList: [...list, ...multiSelect[categoryKey]?.filter(item => newSelectedValues.includes(item.id))],
                                }));
                                return updatedValues;
                              });
                            }}
                            searchable
                            clearable
                          />
                        </div>
                      )}
                      <Modal
                        opened={pair.openModal}
                        onClose={() => openModals(index, false)}
                        disabled={isCondition || pair.key === null}
                        title="Search all categories"
                        centered
                        size="lg"
                        className="pm-modal"
                      >
                        <div>
                          {!pair.value || pair.options.length > 0 ? (
                            <div style={{ padding: '0 20px' }}>
                              <input type="text" id="product-category-search-input" placeholder="Enter a category name" />
                            </div>
                          ) : ''}
                          {!pair.value || pair.options.length > 0 ? (
                            <div role="list">
                              <div className="pm-category-child">
                                <span className="pm-category-child-level">Level {pair.count}</span>
                                <hr />
                              </div>
                              <div className="pm-category-child">
                                {pair.options.map((cat) => (
                                  <ul className="pm-category-child-list" key={cat.id}>
                                    <li tabIndex="0" onClick={() => selectCategory(index, cat)}>
                                      <span>{cat.name}</span>
                                    </li>
                                  </ul>
                                ))}
                              </div>
                            </div>
                          ) : ''}
                          {pair.heirarchyLabel && (
                            <div className="pm-category-hierarchy">
                              <span className="vd-text-body vd-util-text-overflow-break-word">{pair.heirarchyLabel}</span>
                              <button
                                aria-label="Remove selected category"
                                type="button"
                                disabled={isCondition}
                                className="pm-category-btn"
                                onClick={() => removeCategory(index)}
                              >
                                <FontAwesomeIcon className="fa" icon={faTrash} />
                              </button>
                            </div>
                          )}
                        </div>
                      </Modal>
                      <span className="pm-error-message">{inputError?.categoryErrorMessage}</span>
                    </div>
                  </div>
                </Grid.Col>
              </React.Fragment>
            ))}
          </Grid>
        </form>
        {!Boolean(product?.orderDriven) && (
          <section className="pm-variant" style={{ border: "1px solid #675f5f3a", padding: "1rem", borderRadius: "5px", marginBottom: "1.5rem", marginTop: "1.5rem" }}>
            <h4 style={{ margin: "0 0 12px 0", fontWeight: "bold", fontSize: "16px", color: "#333" }}>Variant Details</h4>
            <div className="pm-variant-form-wrap" style={{ marginTop: "0" }}>
              <Grid className="pm-variant-row">
                {selectedPairsVariant.map((pair, index) => (
                  <React.Fragment key={index}>
                    <Grid.Col span={6} className="pm-variant-col">
                      <div className="pm-variant-row">
                        <div className="pm-variant-label">
                          <label style={{ fontWeight: "bold" }}>
                            Variant Name  <span className="pm-error-message">*</span>
                          </label>
                        </div>
                        <div className="pm-input-wrapper">
                          <B2BSelect
                            value={pair.key}
                            data={getAvailableKeysVariant(index)}
                            clearable
                            onChange={(e) => handleSelectChangeVariant(index, e)}
                            disabled={isCondition}
                            className="pm-variant-input"
                          />
                          {inputError?.VariantErrorMessage && (
                            <span className="pm-error-message">{inputError.VariantErrorMessage}</span>
                          )}
                        </div>
                      </div>
                    </Grid.Col>

                    {/* Variant Value */}
                    <Grid.Col span={6} className="pm-variant-col">
                      <div className="pm-variant-row">
                        <div className="pm-variant-label">
                          <label style={{ fontWeight: "bold" }}>
                            Variant Value <span className="pm-error-message">*</span>
                          </label>
                        </div>
                        <div className="pm-input-wrapper">
                          {pair.key === 'Solid / Pattern' ? (
                            <B2BSelect
                              value={Array.isArray(pair.values) ? pair.values[0] : ''}
                              data={Array.isArray(attributes[pair.key])
                                ? attributes[pair.key].map((item) => ({ value: item.id, label: item.value }))
                                : []
                              }
                              onChange={(value) => {
                                if (!isCondition) handleSelectSolidChange(index, value);
                              }}
                              clearable
                              disabled={isCondition}
                              readOnly={isCondition}
                              className="pm-variant-input"
                            />
                          ) : (
                            <div className="pm-variant-pills">
                              <B2BPillsInput
                                value={Array.isArray(pair.values) ? pair.values : []}
                                data={Array.isArray(attributes[pair.key])
                                  ? attributes[pair.key].map((item) => ({ value: item.id, label: item.value }))
                                  : []
                                }
                                onChange={(values) => {
                                  if (!isCondition) handleMultiSelectChangeVariant(index, values);
                                }}
                                disabled={isCondition}
                                readOnly={isCondition}
                                existingValues={existingPairs[pair.key] || []}
                                className="pm-variant-pills-input"
                              />
                            </div>
                          )}
                          {index > 0 && !existingPairsKeys.includes(pair.key) && (
                            <button
                              type="button"
                              className="pm-variant-btn"
                              onClick={() => removePairVariant(index)}
                              disabled={isCondition}
                              readOnly={isCondition}
                              style={{ marginTop: '0.5rem' }}
                            >
                              <FontAwesomeIcon className="fa" icon={faTrash} />
                            </button>
                          )}
                        </div>
                      </div>
                    </Grid.Col>
                  </React.Fragment>
                ))}
              </Grid>
            </div>
            <div className="pm-variant-info">
              <h3 className="pm-variant-sub-heading" role="heading" aria-level="3" style={{ marginTop: '1rem' }}>
                This product has {_.size(combinations)} variant
              </h3>
              {inputError?.variantError ? (
                <div className="pm-error-message" style={{ color: '#dc2626', marginTop: '0.25rem' }}>
                  {inputError.variantError}
                </div>
              ) : null}
            </div>
            <div className="pm-variant-table-content" data-cy="variants-table-content">
              <table data-testid="table" className="pm-variant-table">
                <thead>
                  <tr data-testid="table-row" className="pm-variant-table-header">
                    <th data-testid="table-head-cell" className="pm-variant-table-head-cell" aria-sort="none">
                      Variant name
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="pm-variant-table-row">
                    <td className="pm-variant-table-cell" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '1rem' }}>
                      {product?.newProductVariants?.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleToggle(index)}
                          className={`pm-variant-badge ${isRowExpanded(index) ? 'pm-variant-badge--expanded' : ''}`}
                          style={{ cursor: 'pointer', padding: '4px 10px', display: 'inline-flex', alignItems: 'center' }}
                        >
                          <div className="pm-variant-badge-content">
                            <div className="pm-variant-badge-title" data-cy="badgeHeader" data-testid="badgeHeader">
                              <h5 style={{ fontSize: '13px', fontWeight: '500', margin: 0 }}>{item.name}</h5>
                            </div>
                          </div>
                        </div>
                      ))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default ProductManagement;